<template>
  <div class="wrapper form-group">
    <webshipper-input-label
      :label="label"
      :value="value"
      :default_value="default_value"
      @revert="update_value($event)"
    ></webshipper-input-label>
    <div class="btn-group btn-group-lg d-flex" role="group">
      <button
        class="btn px-5"
        v-for="option in options"
        type="button"
        :class="{ 'btn-primary': value_model === option, 'btn-outline-secondary': value_model !== option }"
        @click="update_value(option)"
      >
        {{ option.toString() | t }}
      </button>
    </div>
    <webshipper-input-revert
      v-if="has_revert"
      :value="value_model"
      :default_value="default_value"
      @revert="update_value($event)"
    ></webshipper-input-revert>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean | String | null,
      required: true
    },
    default_value: {
      type: Boolean | String | null,
      required: false,
      default: null
    },
    select_first_when_empty_model: {
      type: Boolean,
      required: false,
      default: true
    },
    has_revert: {
      type: Boolean,
      required: false,
      default: true
    },
    label: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      options: [true, false]
    };
  },
  computed: {
    value_model: {
      get() {
        if (this.value !== null && this.value !== '') {
          return this.value;
        }

        if (this.default_value !== null) {
          return this.default_value;
        }

        if (this.select_first_when_empty_model && this.options.length > 0) {
          this.$emit('input', this.options[0]);
          return this.options[0];
        }

        return null;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    revert(event) {
      this.$emit('input', event);
    },
    update_value(event) {
      if (this.value_model === event.value) {
        return;
      }
      this.$emit('input', event);
    }
  }
};
</script>
